import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import { AppConstants } from '../constants';

@Injectable({ providedIn: 'root' })
export class UserSessionTrackingService {
  private storageService = inject(StorageService);

  getSessionId(): string {
    let id = this.storageService.getLocal<string>(AppConstants.STORAGE_KEYS.UserSessionId);
    if (!id) {
      id = this.generateUuidV4();
      this.storageService.setLocal(AppConstants.STORAGE_KEYS.UserSessionId, id);
    }
    return id;
  }

  private generateUuidV4(): string {
    const cryptoRef = globalThis.crypto;
    if (cryptoRef?.randomUUID) {
      return cryptoRef.randomUUID();
    }
    const bytes = new Uint8Array(16);
    cryptoRef.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
  }
}
